/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import { Button, Card, Col, Form, Checkbox } from "antd";
import PageToolbar from "../../components/PageToolbar";
import { Row } from "antd/es/grid";
import DateTimePicker from "../../components/DateTimePicker";
import moment from "moment";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import GenericSelector from "../../components/GenericSelector";
import TableIDs from "../../data/TableIDs";
import ReportExcelBtn from "../../components/ReportExcelBtn";
import ReportFavoriteSave from "../../components/ReportFavoriteSave";


class SumDocsExcel extends Component {
    constructor(props: Props) {
        super(props);

        this.state = {
            ...this.getTypeDates(2),
            _branchList: "",
            _docTypeList: "",
            _viewPayItem: 0,
        };

        this.selectors = [
            { id: TableIDs.genericSelectorDocumentTypes, api: "get_document_types_list" },
        ];

        this.selectors.forEach(x => {
            if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector }
        });

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    getTypeDates = (type) => {

        switch (type) {
            case 1: return { _fromDate: moment().day(0).format("YYYY-MM-DD"), _toDate: moment().format("YYYY-MM-DD") }
            case 2: return { _fromDate: moment().day(0).add(-7, "day").format("YYYY-MM-DD"), _toDate: moment().day(0).add(-1, "day").format("YYYY-MM-DD") }
            case 3: return { _fromDate: moment().startOf("month").format("YYYY-MM-DD"), _toDate: moment().format("YYYY-MM-DD") }
            case 4: return { _fromDate: moment().startOf("month").add(-1, "month").format("YYYY-MM-DD"), _toDate: moment().startOf("month").add(-1, "day").format("YYYY-MM-DD") }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setState(this.props.ui.favoriteParams)
        }
    }

    createExcel = () => {
        const params = this.getReportParams()
        this.props.ActionQueue.addToQueue({ action: this.props.dataActions.generateReport, args: [this.props.user.companyCode, this.props.user.token, params] });
    }

    getReportParams = () => {
        let dataSend = { ...this.state }
        if (!dataSend._branchList) dataSend = { ...dataSend, _branchList: this.props.data.GENERIC_SELECTOR_BRANCHES?.dataset.map(x => x.code).join(",") }
        if (!dataSend._docTypeList) dataSend = { ...dataSend, _docTypeList: this.props.docTypeList }

        return {
            ...dataSend,
            isSales: this.props.isSales ? "1" : "0",
            isMoves: this.props.isMoves ? "1" : "0",
            reportName: this.props.reportName,
            REPORT_LOCALE: this.getText(101),
        }
    }

    render() {
        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        const mobile = window.innerWidth > 600 ? false : true;

        // let dataSend = { ...this.state }
        // if (!dataSend._branchList) dataSend = { ...dataSend, _branchList: this.props.data.GENERIC_SELECTOR_BRANCHES?.dataset.map(x => x.code).join(",") }
        // if (!dataSend._docTypeList) dataSend = { ...dataSend, _docTypeList: this.props.docTypeList }


        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={this.props.title} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: mobile ? '95%' : 800 }}
                bodyStyle={{ padding: 16 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                actions={[
                    <ReportFavoriteSave
                        {...this.props}
                        params={this.getReportParams()}
                        datesToFavorites={[
                            { field: '_fromDate', label: gt(21306) },
                            { field: '_toDate', label: gt(21307) },
                        ]}
                    />,
                    <Button type="primary" onClick={this.createExcel} loading={this.props.ui.workInProgress}>{gt(21310)}</Button>,
                ]}>
                <Row>
                    <Col span={mobile ? 24 : 8}>
                        <Form.Item label={gt(21306)}>
                            <DateTimePicker
                                format="DD/MM/YYYY"
                                value={this.state._fromDate}
                                onChange={e => { this.setState({ _fromDate: e }) }}
                                minDate={this.state._toDate ? moment(this.state._toDate).add(-1, "month").format("YYYY-MM-DD") : null}
                                maxDate={this.state._toDate}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={mobile ? 24 : 8}>
                        <Form.Item label={gt(21307)}>
                            <DateTimePicker
                                format="DD/MM/YYYY"
                                value={this.state._toDate}
                                onChange={e => { this.setState({ _toDate: e }) }}
                                minDate={this.state._fromDate}
                                maxDate={this.state._fromDate ? moment(this.state._fromDate).add(1, "month").format("YYYY-MM-DD") : null}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={mobile ? 24 : 8}>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(1)) }}>{gt(22038)}</Button>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(2)) }}>{gt(22039)}</Button>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(3)) }}>{gt(22040)}</Button>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(4)) }}>{gt(22041)}</Button>
                    </Col>
                </Row>

                <Form.Item label={gt(21308)}>
                    <GenericSelectorBranches
                        {...this.props}
                        multi
                        value={this.state._branchList ? this.state._branchList.split(",") : []}
                        onChange={e => { this.setState({ _branchList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>

                <Form.Item label={gt(21309)}>
                    <GenericSelector
                        {...this.props}
                        multi
                        {...this.selectors[0]}
                        filterList={this.props.docTypeList.split(",")}
                        value={this.state._docTypeList ? this.state._docTypeList.split(",") : []}
                        onChange={e => { this.setState({ _docTypeList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                {this.props.isSales && this.props.reportName == "reports/DailySalesExcel.xls" && (
                    <Form.Item>
                        <Checkbox
                            checked={this.state._viewPayItem == 1}
                            onChange={e => { this.setState({ _viewPayItem: e.target.checked ? 1 : 0 }) }}>
                            {gt(22732)}
                        </Checkbox>
                    </Form.Item>)}
            </Card>


        </div>)
    }

}

export default SumDocsExcel;